export default __webpack_public_path__ + "static/media/HP.6dd097ae.png";